import { render, staticRenderFns } from "./statrgyManagerForm.vue?vue&type=template&id=10ccf42c&scoped=true"
import script from "./statrgyManagerForm.vue?vue&type=script&lang=js"
export * from "./statrgyManagerForm.vue?vue&type=script&lang=js"
import style0 from "./statrgyManagerForm.vue?vue&type=style&index=0&id=10ccf42c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ccf42c",
  null
  
)

export default component.exports